import React from 'react';
import { FormattedMessage } from 'react-intl';
import Collapsible from 'react-collapsible';
import {AnswersList as NeuroAnswersList, useAnalytics} from "@ignitesales/neuro-application";

const AnswersList = ({ answers = {}, isCollapsibleListOpen = false }) => {
  const { actionCompleted } = useAnalytics();
  const componentCssBEM = 'answersList';
  const onClick = () => {
    actionCompleted('answerDetailsClicked');
  };

  const header = <div className={ `${ componentCssBEM }__header` } onClick={ onClick }><h1>
    <FormattedMessage id="answersList.title" tagName="span"/></h1></div>;

  return (
    <Collapsible
      classParentString={ `${ componentCssBEM } container` }
      openedClassName={ `${ componentCssBEM }--opened` }
      trigger={ header }
      open={ isCollapsibleListOpen }
    >
      <NeuroAnswersList answers={answers} />
    </Collapsible>
  );
};

export default AnswersList;
